import { hillo } from 'hillo'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import GlobalConfig from '@/model/global/GlobalSettings'
import VoucherTypes from '@/model/dataLayer/api/Vip/VoucherTypes'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import dayjs from 'dayjs'

const BLPost = 'membership/post/'

const entity = {
  images: {
    type: IKDataEntity.Types.Images
  },
  title: {},
  outsideUrl: {},
  postContentMd: {
    formConfig: {
      textArea: true,
      maxLength: 2000
    }
  },
  voucherTypeId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => { return VoucherTypes.getList() },
        itemText: 'name',
        itemValue: 'id'
      }
    }
  },
  visibleAt: {
    type: IKDataEntity.Types.Date
  },
  blId: {
    form: false
  }
}
const config = {
  load: async function () {
    return (await hillo.get(cloudV2Url + BLPost + 'blId/' + GlobalConfig.blId)).map(it => {
      if (it.visibleAt) {
        it.visibleAt = dayjs(it.visibleAt).format('YYYY-MM-DD HH:mm:ss')
      }
      return it
    })
  },
  add: async function (item) {
    if (item.visibleAt) {
      item.visibleAt = dayjs(item.visibleAt).format('YYYY-MM-DD') + 'T00:00:00'
    }
    item.blId = GlobalConfig.blId
    return (await hillo.jsonPost(cloudV2Url + BLPost + 'save', {
      ...item
    })).content
  },
  edit: async function (item) {
    if (item.visibleAt) {
      item.visibleAt = dayjs(item.visibleAt).format('YYYY-MM-DD') + 'T00:00:00'
    }
    return (await hillo.jsonPost(cloudV2Url + BLPost + 'save', {
      ...item
    })).content
  },
  remove: async function (id) {
    return (await hillo.jsonPost(cloudV2Url + BLPost + 'delete/' + id, {
      id
    })).content
  }
}

export default IKDataEntity.ModelFactory(entity, config)
